"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IMG = exports.IFRAME = exports.I = exports.HR = exports.HEADER = exports.HEAD = exports.H6 = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = exports.FORM = exports.FOOTER = exports.FIGURE = exports.FIGCAPTION = exports.FIELDSET = exports.EMBED = exports.EM = exports.DT = exports.DL = exports.DIV = exports.DIALOG = exports.DFN = exports.DETAILS = exports.DEL = exports.DD = exports.DATALIST = exports.DATA = exports.COLGROUP = exports.COL = exports.CODE = exports.CITE = exports.CAPTION = exports.CANVAS = exports.BUTTON = exports.BR = exports.BODY = exports.BLOCKQUOTE = exports.BDO = exports.BDI = exports.BASE = exports.B = exports.AUDIO = exports.ASIDE = exports.ARTICLE = exports.AREA = exports.ADDRESS = exports.ABBR = exports.A = void 0;
exports.TRACK = exports.TR = exports.TITLE = exports.TIME = exports.THEAD = exports.TH = exports.TFOOT = exports.TEXTAREA = exports.TEMPLATE = exports.TD = exports.TBODY = exports.TABLE = exports.SVG = exports.SUP = exports.SUMMARY = exports.SUB = exports.STRONG = exports.SPAN = exports.SMALL = exports.SELECT = exports.SECTION = exports.SAMP = exports.S = exports.RUBY = exports.RT = exports.RP = exports.Q = exports.PROGRESS = exports.PRE = exports.PICTURE = exports.PARAM = exports.P = exports.OUTPUT = exports.OPTION = exports.OPTGROUP = exports.OL = exports.OBJECT = exports.NAV = exports.METER = exports.META = exports.MARK = exports.MAP = exports.MAIN = exports.LINK = exports.LI = exports.LEGEND = exports.LABEL = exports.KBD = exports.INS = exports.INPUT = void 0;
exports.MATERIALUISVGICON = exports.INLINESVG = exports.WBR = exports.VIDEO = exports.UL = exports.U = void 0;
var tagConversion_1 = require("./tagConversion");
require("./Responsive.css");
var react_inlinesvg_1 = __importDefault(require("react-inlinesvg"));
var SvgIcon_1 = __importDefault(require("@material-ui/core/SvgIcon"));
exports.A = (0, tagConversion_1.vsxTagConversion)("a");
exports.ABBR = (0, tagConversion_1.vsxTagConversion)("abbr");
exports.ADDRESS = (0, tagConversion_1.vsxTagConversion)("address");
exports.AREA = (0, tagConversion_1.vsxTagConversion)("area");
exports.ARTICLE = (0, tagConversion_1.vsxTagConversion)("article");
exports.ASIDE = (0, tagConversion_1.vsxTagConversion)("aside");
exports.AUDIO = (0, tagConversion_1.vsxTagConversion)("audio");
exports.B = (0, tagConversion_1.vsxTagConversion)("b");
exports.BASE = (0, tagConversion_1.vsxTagConversion)("base");
exports.BDI = (0, tagConversion_1.vsxTagConversion)("bdi");
exports.BDO = (0, tagConversion_1.vsxTagConversion)("bdo");
exports.BLOCKQUOTE = (0, tagConversion_1.vsxTagConversion)("blockquote");
exports.BODY = (0, tagConversion_1.vsxTagConversion)("body");
exports.BR = (0, tagConversion_1.vsxTagConversion)("br");
exports.BUTTON = (0, tagConversion_1.vsxTagConversion)("button");
exports.CANVAS = (0, tagConversion_1.vsxTagConversion)("canvas");
exports.CAPTION = (0, tagConversion_1.vsxTagConversion)("caption");
exports.CITE = (0, tagConversion_1.vsxTagConversion)("cite");
exports.CODE = (0, tagConversion_1.vsxTagConversion)("code");
exports.COL = (0, tagConversion_1.vsxTagConversion)("col");
exports.COLGROUP = (0, tagConversion_1.vsxTagConversion)("colgroup");
exports.DATA = (0, tagConversion_1.vsxTagConversion)("data");
exports.DATALIST = (0, tagConversion_1.vsxTagConversion)("datalist");
exports.DD = (0, tagConversion_1.vsxTagConversion)("dd");
exports.DEL = (0, tagConversion_1.vsxTagConversion)("del");
exports.DETAILS = (0, tagConversion_1.vsxTagConversion)("details");
exports.DFN = (0, tagConversion_1.vsxTagConversion)("dfn");
exports.DIALOG = (0, tagConversion_1.vsxTagConversion)("dialog");
exports.DIV = (0, tagConversion_1.vsxTagConversion)("div");
exports.DL = (0, tagConversion_1.vsxTagConversion)("dl");
exports.DT = (0, tagConversion_1.vsxTagConversion)("dt");
exports.EM = (0, tagConversion_1.vsxTagConversion)("em");
exports.EMBED = (0, tagConversion_1.vsxTagConversion)("embed");
exports.FIELDSET = (0, tagConversion_1.vsxTagConversion)("fieldset");
exports.FIGCAPTION = (0, tagConversion_1.vsxTagConversion)("figcaption");
exports.FIGURE = (0, tagConversion_1.vsxTagConversion)("figure");
exports.FOOTER = (0, tagConversion_1.vsxTagConversion)("footer");
exports.FORM = (0, tagConversion_1.vsxTagConversion)("form");
exports.H1 = (0, tagConversion_1.vsxTagConversion)("h1");
exports.H2 = (0, tagConversion_1.vsxTagConversion)("h2");
exports.H3 = (0, tagConversion_1.vsxTagConversion)("h3");
exports.H4 = (0, tagConversion_1.vsxTagConversion)("h4");
exports.H5 = (0, tagConversion_1.vsxTagConversion)("h5");
exports.H6 = (0, tagConversion_1.vsxTagConversion)("h6");
exports.HEAD = (0, tagConversion_1.vsxTagConversion)("head");
exports.HEADER = (0, tagConversion_1.vsxTagConversion)("header");
exports.HR = (0, tagConversion_1.vsxTagConversion)("hr");
exports.I = (0, tagConversion_1.vsxTagConversion)("i");
exports.IFRAME = (0, tagConversion_1.vsxTagConversion)("iframe");
exports.IMG = (0, tagConversion_1.vsxTagConversion)("img");
exports.INPUT = (0, tagConversion_1.vsxTagConversion)("input");
exports.INS = (0, tagConversion_1.vsxTagConversion)("ins");
exports.KBD = (0, tagConversion_1.vsxTagConversion)("kbd");
exports.LABEL = (0, tagConversion_1.vsxTagConversion)("label");
exports.LEGEND = (0, tagConversion_1.vsxTagConversion)("legend");
exports.LI = (0, tagConversion_1.vsxTagConversion)("li");
exports.LINK = (0, tagConversion_1.vsxTagConversion)("link");
exports.MAIN = (0, tagConversion_1.vsxTagConversion)("main");
exports.MAP = (0, tagConversion_1.vsxTagConversion)("map");
exports.MARK = (0, tagConversion_1.vsxTagConversion)("mark");
exports.META = (0, tagConversion_1.vsxTagConversion)("meta");
exports.METER = (0, tagConversion_1.vsxTagConversion)("meter");
exports.NAV = (0, tagConversion_1.vsxTagConversion)("nav");
exports.OBJECT = (0, tagConversion_1.vsxTagConversion)("object");
exports.OL = (0, tagConversion_1.vsxTagConversion)("ol");
exports.OPTGROUP = (0, tagConversion_1.vsxTagConversion)("optgroup");
exports.OPTION = (0, tagConversion_1.vsxTagConversion)("option");
exports.OUTPUT = (0, tagConversion_1.vsxTagConversion)("output");
exports.P = (0, tagConversion_1.vsxTagConversion)("p");
exports.PARAM = (0, tagConversion_1.vsxTagConversion)("param");
exports.PICTURE = (0, tagConversion_1.vsxTagConversion)("picture");
exports.PRE = (0, tagConversion_1.vsxTagConversion)("pre");
exports.PROGRESS = (0, tagConversion_1.vsxTagConversion)("progress");
exports.Q = (0, tagConversion_1.vsxTagConversion)("q");
exports.RP = (0, tagConversion_1.vsxTagConversion)("rp");
exports.RT = (0, tagConversion_1.vsxTagConversion)("rt");
exports.RUBY = (0, tagConversion_1.vsxTagConversion)("ruby");
exports.S = (0, tagConversion_1.vsxTagConversion)("s");
exports.SAMP = (0, tagConversion_1.vsxTagConversion)("samp");
exports.SECTION = (0, tagConversion_1.vsxTagConversion)("section");
exports.SELECT = (0, tagConversion_1.vsxTagConversion)("select");
exports.SMALL = (0, tagConversion_1.vsxTagConversion)("small");
exports.SPAN = (0, tagConversion_1.vsxTagConversion)("span");
exports.STRONG = (0, tagConversion_1.vsxTagConversion)("strong");
exports.SUB = (0, tagConversion_1.vsxTagConversion)("sub");
exports.SUMMARY = (0, tagConversion_1.vsxTagConversion)("summary");
exports.SUP = (0, tagConversion_1.vsxTagConversion)("sup");
exports.SVG = (0, tagConversion_1.vsxTagConversion)("svg");
exports.TABLE = (0, tagConversion_1.vsxTagConversion)("table");
exports.TBODY = (0, tagConversion_1.vsxTagConversion)("tbody");
exports.TD = (0, tagConversion_1.vsxTagConversion)("td");
exports.TEMPLATE = (0, tagConversion_1.vsxTagConversion)("template");
exports.TEXTAREA = (0, tagConversion_1.vsxTagConversion)("textarea");
exports.TFOOT = (0, tagConversion_1.vsxTagConversion)("tfoot");
exports.TH = (0, tagConversion_1.vsxTagConversion)("th");
exports.THEAD = (0, tagConversion_1.vsxTagConversion)("thead");
exports.TIME = (0, tagConversion_1.vsxTagConversion)("time");
exports.TITLE = (0, tagConversion_1.vsxTagConversion)("title");
exports.TR = (0, tagConversion_1.vsxTagConversion)("tr");
exports.TRACK = (0, tagConversion_1.vsxTagConversion)("track");
exports.U = (0, tagConversion_1.vsxTagConversion)("u");
exports.UL = (0, tagConversion_1.vsxTagConversion)("ul");
exports.VIDEO = (0, tagConversion_1.vsxTagConversion)("video");
exports.WBR = (0, tagConversion_1.vsxTagConversion)("wbr");
exports.INLINESVG = (0, tagConversion_1.vsxTagConversion)(react_inlinesvg_1.default);
exports.MATERIALUISVGICON = (0, tagConversion_1.vsxTagConversion)(SvgIcon_1.default);